import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import {cssClassMap} from 'rendering-commons/SportCssMap';

import {removeCouponRate as removeCouponRateAction} from 'actions/creators/CouponRate';
import {requestBetTypes as requestBetTypesAction} from 'actions/creators/HistoryBet';

import {isRateUnavailable, rateFactorChangeConfirmNeeded} from './rateUtils';

import * as BetTypeMap from 'constants/BetType';

const messages = defineMessages({
    rateChanged: {
        id: 'coupon.rate_changed',
        defaultMessage: 'Коэфф недоступен'
    },
    rateUnavailable: {
        id: 'coupon.rate_unavailable',
        defaultMessage: 'Прием закрыт'
    },
    confirmRateValueChange: {
        id: 'coupon.confirm_rate_value_change',
        defaultMessage: 'Принять изменения'
    },
    stake: {
        id: 'coupon.stake_title',
        defaultMessage: 'Ставка:'
    },
    rate: {
        id: 'coupon.rate_title',
        defaultMessage: 'Коэфф:'
    },
    sumLabel: {
        id: 'coupon.sum_label',
        defaultMessage: 'Сумма'
    }
});

class BetSlip extends React.Component {
    static propTypes = {
        rate: React.PropTypes.object,
        match: React.PropTypes.object,
        score: React.PropTypes.object,
        outcome: React.PropTypes.object,
        bettingMode: React.PropTypes.object,
        removeCouponRateAction: React.PropTypes.func.isRequired,
        requestBetTypesAction: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._onRemoveClick = this._onRemoveClick.bind(this);
    }

    _onRemoveClick(e) {
        e.preventDefault();
        Promise.resolve(
            this.props.removeCouponRateAction({rateId: this.props.rate.get('id')})
        ).then(
            () => this.props.onUpdateSize()
        );
        this.props.requestBetTypesAction();
    }

    render() {
        if (!this.props.betSlip) {
            return false;
        }

        const rate = this.props.rate;
        const match = this.props.match;
        const score = this.props.score;
        const outcome = this.props.outcome;
        const bettingMode = this.props.bettingMode;
        const stake = this.props.stake;
        const betSlipCount = this.props.betSlipCount;
        const originalValue = rate.get('value');
        const actualValue = rate.get('actualValue');
        const betTypes = this.props.betTypes;
        const currentBetTypeIndex = this.props.currentBetTypeIndex;

        if (!match) {
            return false;
        }

        const betType = betTypes.get(currentBetTypeIndex);
        const currentBetTypeIsSingle = betType && betType.type == BetTypeMap.SINGLE;

        const acceptFactorChange = bettingMode.get('acceptFactorChange');

        const sportIconCls = 'sport-icon svg-' + cssClassMap[rate.get('sportId')];

        let unavailableSpan;
        if (isRateUnavailable(rate)) {
            unavailableSpan = (
                <FormattedMessage {...messages.rateUnavailable}>
                    {(message) => <span className="event-rate event-rate__unavailable">{message}</span>}
                </FormattedMessage>
            );
        } else if (rateFactorChangeConfirmNeeded(rate, acceptFactorChange)) {
            unavailableSpan = (
                <FormattedMessage {...messages.rateChanged}>
                    {(message) => <span className="event-rate event-rate__unavailable">{message}</span>}
                </FormattedMessage>
            );
        }

        let scoreSpan = undefined;
        if (score) {
            let score1 = score.get('score1');
            score1 = score1 === null ? 0 : score1;

            let score2 = score.get('score2');
            score2 = score2 === null ? 0 : score2;

            scoreSpan = (
                <span className="current-score">
                    <strong>{score1 + ':' + score2}</strong>
                </span>
            );
        }

        let eventSingleBetAmount = undefined;
        if (betSlipCount > 1) {
            eventSingleBetAmount = (
                <span className="event-single-bet-amount"><FormattedMessage{...messages.sumLabel} />: <strong>{stake}</strong></span>
            );
        }

        let rateSpan = (
            <span className="event-rate">
                <FormattedMessage {...messages.rate} />
                <strong>{originalValue}</strong>
                {currentBetTypeIsSingle && eventSingleBetAmount}
                {unavailableSpan}
            </span>
        );

        if (actualValue && originalValue !== actualValue) {
            let cls = 'new-rate';
            if (originalValue < actualValue) {
                cls += ' up';
            } else {
                cls += ' down';
            }

            rateSpan = (
                <div className="rate changed">
                    <FormattedMessage {...messages.rate} />
                    <span className="old-rate"> {originalValue}</span>
                    {'\u00A0'}
                    <span className={cls}>{actualValue}</span>
                    {unavailableSpan}
                </div>
            );
        }

        let matchName = match.get('name');
        if (match.get('notice')) {
            matchName += '(' + match.get('notice') + ')'
        }

        return (
            <li className="coupons-list-item">
                <span className="event-name">
                    <span className={sportIconCls} />
                    {scoreSpan}
                    {matchName}<br/>
                    {outcome.get('name')}
                </span>
                <span className="event-type">
                    <FormattedMessage {...messages.stake} />
                    <strong>{rate.get('shortName')}</strong>
                </span>
                {rateSpan}
                <a href="#" className="close" onClick={this._onRemoveClick}>{'\u00A0'}</a>
            </li>
        );
    }
}

function select(state, props) {
    const betSlipId = props.id;
    const betSlip = state.application.getIn(['coupon', 'betSlips', betSlipId]);
    const betSlipCount = state.application.getIn(['coupon', 'betSlips']).size;
    const stake = state.application.getIn(['coupon', 'amount']);
    const currentBetTypeIndex = state.application.getIn(['coupon', 'currentBetTypeIndex']);
    const betTypes = state.application.getIn(['coupon', 'betTypes']);

    let rate, match, score, outcome;
    if (betSlip) {
        rate = betSlip.get('rate');
        match = betSlip.get('match');
        score = betSlip.get('score');
        outcome = betSlip.get('outcome');
    }

    const bettingMode = state.application.get('bettingMode');

    return {
        betSlip,
        rate,
        match,
        score,
        outcome,
        bettingMode,
        stake,
        betSlipCount,
        currentBetTypeIndex,
        betTypes
    };
}

export default connect(select, {
    removeCouponRateAction, requestBetTypesAction
})(BetSlip);



// WEBPACK FOOTER //
// ./js/sport-betting/components/bet-panel-control/coupon/BetSlip.jsx